import type { NuxtApp } from "#app/nuxt";
import type { AsyncDataOptions, KeysOf } from "#app/composables/asyncData";

export function useSyncCachedAsyncData<
  ResT,
  DataE = Error,
  DataT = ResT,
  PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
  DefaultT = null,
>(
  key: string,
  handler: (ctx?: NuxtApp) => Promise<ResT>,
  options?: AsyncDataOptions<ResT, DataT, PickKeys, DefaultT>,
): ReturnType<typeof useAsyncData<ResT, DataE, DataT, PickKeys, DefaultT>> {
  return useAsyncData<ResT, DataE, DataT, PickKeys, DefaultT>(key, handler, {
    ...(options || {}),
    getCachedData(key: string, nuxt: NuxtApp) {
      const instance = getCurrentInstance();
      return !instance?.isMounted
        ? nuxt.payload.data[key]
        : nuxt.static.data[key];
    },
  });
}
